import(/* webpackMode: "eager" */ "/codebuild/output/src933875154/src/dgbet/src/app/[sportSlug]/[countrySlug]/page.tsx");
